import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './Context/Auth/Provider';
import { initializeIcons } from '@fluentui/react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { NotificationProvider } from './Context/Notification/Provider';
import { PermissionsProvider } from './Context/Permissions/Provider';
import { EnvironmentProvider } from './Context/Environment/Context';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
initializeIcons();
root.render(
  // <React.StrictMode>
  <FluentProvider theme={webLightTheme}>
    <BrowserRouter>
      <NotificationProvider>
        <AuthProvider>
          <PermissionsProvider>
            <EnvironmentProvider>
              <App />
            </EnvironmentProvider>
          </PermissionsProvider>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  </FluentProvider>
  // </React.StrictMode>
);
